/**
 * @generated SignedSource<<38520235dc2de9c32fce126bf9269c61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseSectionsPreview_lesson$data = {
  readonly canAccess: boolean;
  readonly completed: boolean;
  readonly course: {
    readonly slug: string;
  };
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly " $fragmentType": "courseSectionsPreview_lesson";
};
export type courseSectionsPreview_lesson$key = {
  readonly " $data"?: courseSectionsPreview_lesson$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview_lesson">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseSectionsPreview_lesson",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "CourseClass",
  "abstractKey": "__isCourseClass"
};
})();

(node as any).hash = "d4c1d5cdebcbbb025c904a174f26050a";

export default node;
